var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "M5.242.46h6.488a4.79 4.79 0 0 1 4.782 4.782v6.488a4.79 4.79 0 0 1-4.782 4.782H5.242A4.79 4.79 0 0 1 .459 11.73V5.242A4.79 4.79 0 0 1 5.242.459m6.488 14.438a3.167 3.167 0 0 0 3.168-3.168V5.242a3.167 3.167 0 0 0-3.168-3.168H5.242a3.167 3.167 0 0 0-3.168 3.168v6.488a3.167 3.167 0 0 0 3.168 3.168z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "M4.334 8.486a4.157 4.157 0 0 1 4.152-4.152 4.157 4.157 0 0 1 4.152 4.152 4.157 4.157 0 0 1-4.152 4.152 4.157 4.157 0 0 1-4.152-4.152m1.615 0a2.537 2.537 0 1 0 5.074 0 2.537 2.537 0 0 0-5.074 0",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.646,
  cy: 4.365,
  r: 0.995,
  fill: "#98918A"
})));
export default SvgInstagram;